import { useMemo } from "react";
import { useActivitiesContext } from "./ActivitiesContext";
import { useActivities } from "./useActivities";
import { ActivityEventSource } from "./sources/ActivityEventSource";

export function useWorkspaceActivities() {
    const { workspaceId, userId, firestore, kinds } = useActivitiesContext();
    const sources = useMemo(
        () => (workspaceId ? [new ActivityEventSource(workspaceId, userId, firestore, kinds)] : []),
        [workspaceId, userId, firestore, kinds]
    );
    return useActivities(sources);
}
